import CustomNavbar from './Components/Navbar/CustomNavbar';
import { useTranslation } from 'react-i18next';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css'
import MainNavbarMenu from './Components/Navbar/MainNavbarMenu';
import { BrowserRouter as Router, Route, Switch, Link, useLocation } from 'react-router-dom';
import CookieBanner from './Components/CookieBanner/CookieBanner';

import ProductsPage from './Pages/ProductsPage';
import NewsEventsPage from './Pages/NewsAndEvents/NewsEventsPage';
import HansaFlexGroupPage from './Pages/HansaFlexGroupPages/HansaFlexGroupPage';
import HomePage from './Pages/HomePage';
import BrazilServicos from './Pages/BrazilServicos';
import Local from './Pages/NewsAndEvents/Local';
import Measurement from './Pages/NewsAndEvents/Measurement';
import LessHeadache from './Pages/NewsAndEvents/LessHeadache';
import Nonconductivenews from './Pages/NewsAndEvents/Nonconductivenews';
import XCodeNews from './Pages/NewsAndEvents/XCodeNews';
import WearAndTear from './Pages/NewsAndEvents/WearAndTear';
import HydraulicHoseCleaning from './Pages/NewsAndEvents/HydraulicHoseCleaning';

import HfFooter from './Components/HfFooter/HfFooter';
import Journey from './Pages/HansaFlexBrazilPages/Journey';
import Management from './Pages/HansaFlexBrazilPages/Management';
import GroupManagement from './Pages/HansaFlexGroupPages/GroupManagement';
import GroupCertificates from './Pages/HansaFlexGroupPages/GroupCertificates';
import GroupHistory from './Pages/HansaFlexGroupPages/GroupHistory';
import GroupMissionStatement from './Pages/HansaFlexGroupPages/GroupMissionStatement';
import Certificates from './Pages/HansaFlexBrazilPages/Certificates';

import SixtyYearOfHansaflex from './Pages/HansaFlexGroupPages/SixtyYearOfHansaFlex';
import Careers from './Pages/Careers';
import PrivayPolicyPage from './Pages/PrivacyPolicy';
import CookieConsent from 'react-cookie-consent';
import Codeofconduct from './Pages/Codeofconduct';
import ContactUsForm from './Pages/ContactForms/contactUsForm';
import MhsCampaign from './Pages/ContactForms/MhsCampaign';
import MhsprCampaign from './Pages/ContactForms/MhsprCampaign';
import MhsCampaignMS from './Pages/ContactForms/MhsCampaignMS';
import MiningCampaignMG from './Pages/ContactForms/MiningCampaignMG';
import OffshoreCampaign from './Pages/ContactForms/OffshoreCampaign';
import HydraulicHoseCampaignSPABC from './Pages/ContactForms/HydraulicHoseCampaignSPABC';


import HosesAndHoseLines from './Pages/ProductPages/HosesAndHoseLines/HosesAndHoseLines';
import HydraulicHose from './Pages/ProductPages/HosesAndHoseLines/HydraulicHose';
import MetalHoses from './Pages/ProductPages/HosesAndHoseLines/MetalHoses';
import IndustrialHoses from './Pages/ProductPages/HosesAndHoseLines/IndustrialHoses';
import PerformedHoses from './Pages/ProductPages/HosesAndHoseLines/PerformedHoses';
import ExtremelyHighPerformanceHoses from './Pages/ProductPages/HosesAndHoseLines/ExtremelyHighPerformanceHoses';
import HoseLineConfigurator from './Pages/ProductPages/HosesAndHoseLines/HoseLineConfigurator';
import PtfeHoses from './Pages/ProductPages/HosesAndHoseLines/PtfeHoses';
import Accessories from './Pages/ProductPages/HosesAndHoseLines/Accessories';
import DriveAndControlTechnology from './Pages/ProductPages/DriveAndControlTechnology/DriveAndControlTechnology';
import Pumps from './Pages/ProductPages/DriveAndControlTechnology/Pumps';
import HydraulicMotor from './Pages/ProductPages/DriveAndControlTechnology/HydraulicMotor';
import Cylinder from './Pages/ProductPages/DriveAndControlTechnology/Cylinder';
import SwitchesAndSensors from './Pages/ProductPages/DriveAndControlTechnology/SwitchesAndSensors';
import ValveTechnology from './Pages/ProductPages/DriveAndControlTechnology/ValveTechnology/ValveTechnology';
import PipelineInstallationValve from './Pages/ProductPages/DriveAndControlTechnology/ValveTechnology/PipelineInstallationValve';
import CartridgeValves from './Pages/ProductPages/DriveAndControlTechnology/ValveTechnology/CartridgeValves';
import CetopValves from './Pages/ProductPages/DriveAndControlTechnology/ValveTechnology/CetopValves';
import MeasuringTechnology from './Pages/ProductPages/DriveAndControlTechnology/MeasuringTechnology';
import SevenHundredBarHydraulics from './Pages/ProductPages/DriveAndControlTechnology/SevenHundredBarHydraulics';
import PressureAccumulators from './Pages/ProductPages/DriveAndControlTechnology/PressureAccumulators';
import SealingTechnology from './Pages/ProductPages/SealingTechnology';
import Filtration from './Pages/ProductPages/Filtration';
import Pneumatics from './Pages/ProductPages/Pneumatics';
import TechnicalInformation from './Pages/ProductPages/TechnicalInformation';
import Approvals from './Pages/ProductPages/Approvals';
import Catalogues from './Pages/ProductPages/Catalogues';
import HydraulicConnectionTechnology from './Pages/ProductPages/HydraulicConnectionTechnology/HydraulicConnectionTechnology';
import HoseFittings from './Pages/ProductPages/HydraulicConnectionTechnology/HoseFittings';
import PipeFittings from './Pages/ProductPages/HydraulicConnectionTechnology/PipeFittings';
import Adapters from './Pages/ProductPages/HydraulicConnectionTechnology/Adapters';
import Couplings from './Pages/ProductPages/HydraulicConnectionTechnology/Couplings';
import BallValves from './Pages/ProductPages/HydraulicConnectionTechnology/BallValves';
import Flanges from './Pages/ProductPages/HydraulicConnectionTechnology/Flanges';
import Pipelines from './Pages/ProductPages/Pipelines/Pipelines';
import Pipebends from './Pages/ProductPages/Pipelines/Pipebends';
import ExpansionJoints from './Pages/ProductPages/Pipelines/ExpansionJoints';
import PipeendProcessing from './Pages/ProductPages/Pipelines/PipeendProcessing';

import HoseManagement from './Pages/ServicesPages/PreventativeMaintainance/HoseManagement/HoseManagement';
import FluidService from './Pages/ServicesPages/FluidManagement/FluidService';
import MobileService from './Pages/ServicesPages/MobileRapidHydraulicService';
import HydraulicAcademy from './Pages/ServicesPages/HydraulicAccademy';
import OilAnalysis from './Pages/ServicesPages/FluidManagement/OilAnalysis';
import OilFilteringAndCleaning from './Pages/ServicesPages/FluidManagement/OilFilteringAndCleaning';
import AssemblyAndInstallation from './Pages/ServicesPages/AssembellyAndInstallation/AssemblyAndInstallation';
import ModernisationAndOptimisation from './Pages/ServicesPages/AssembellyAndInstallation/ModernisationAndOptimisation';
import PlantProjectPlanningAndManagement from './Pages/ServicesPages/AssembellyAndInstallation/PlantProjectPlanningAndManagement';
import InstallationOfPipeAndHoseLineSystems from './Pages/ServicesPages/AssembellyAndInstallation/InstallationOfPipeAndHoseLineSystems';
import PreventataiveMaintainance from './Pages/ServicesPages/PreventativeMaintainance/PreventataiveMaintainance';
import ServicePackages from './Pages/ServicesPages/PreventativeMaintainance/HoseManagement/ServicePackages';
import XCodeIdentification from './Pages/ServicesPages/PreventativeMaintainance/HoseManagement/XCodeIdentification';
import XCodeManager from './Pages/ServicesPages/PreventativeMaintainance/HoseManagement/XCodeManager/XCodeManager';
import Licenses from './Pages/ServicesPages/PreventativeMaintainance/HoseManagement/XCodeManager/Licenses';
import Inspection from './Pages/ServicesPages/PreventativeMaintainance/Inspection/Inspection';
import IndustrialHoseInspection from './Pages/ServicesPages/PreventativeMaintainance/Inspection/IndustrialHoseInspection';
import DguvInspection from './Pages/ServicesPages/PreventativeMaintainance/Inspection/DguvInspection';
import LiftingPlatformsAndLoadingBridges from './Pages/ServicesPages/PreventativeMaintainance/Inspection/LiftingPlatformsAndLoadingBridges';
import RepairAndOverhaul from './Pages/ServicesPages/RepairAndOverhaul/RepairAndOverhaul';
import PressureAccumulatorsAndAssociatedSystems from './Pages/ServicesPages/RepairAndOverhaul/PressureAccumulatorsAndAssociatedSystems';
import HydraulicCylinderRepair from './Pages/ServicesPages/RepairAndOverhaul/HydraulicCylinderRepair';
import DigitalServices from './Pages/ServicesPages/Digital Services/DigitalServices';
import EDIandBMEcat from './Pages/ServicesPages/Digital Services/EDIandBMEcat';
import Scannersolutions from './Pages/ServicesPages/Digital Services/Scannersolutions';
import Production from './Pages/ServicesPages/Production/Production';
import CustomisedAssembly from './Pages/ServicesPages/Production/CustomisedAssembly';
import SeriesProduction from './Pages/ServicesPages/Production/SeriesProduction';

import Logisticssolutions from './Pages/ServicesPages/Logistics solutions/Logisticssolutions';
import Warehousemanagement from './Pages/ServicesPages/Logistics solutions/Warehousemanagement';
import Kanbandelivery from './Pages/ServicesPages/Logistics solutions/Kanbandelivery'
import Kitting from './Pages/ServicesPages/Logistics solutions/Kitting';
import Hydraulicworkshopcontainers from './Pages/ServicesPages/Logistics solutions/Hydraulicworkshopcontainers';
import Worksinworks from './Pages/ServicesPages/Logistics solutions/Worksinworks';

import Engineering from './Pages/ServicesPages/Enginnering/Engineering';
import EngineeredbyHansaflex from './Pages/ServicesPages/Enginnering/EngineeredbyHansaflex';
import Hydraulicunit from './Pages/ServicesPages/Enginnering/Hydraulicunit';
import Prototypemanufacture from './Pages/ServicesPages/Enginnering/Prototypemanufacture';
import Pressureaccumulatorinspection from './Pages/ServicesPages/Pressureaccumulatorinspection';

import WhatsAppChat from './Components/WhatsAppChat/WhatsAppChat';
import WhoWeAre from './Pages/HansaFlexBrazilPages/WhoWeAre';
import ContactUs from './Pages/HansaFlexBrazilPages/ContactUs';
import AnnualReport from './Pages/HansaFlexGroupPages/AnnualReport';
import UpcomingEvents from './Pages/HansaFlexGroupPages/UpcomingEvents';
import Associations from './Pages/HansaFlexGroupPages/Associations';
import ResponsibilityAndSocialCommitments from './Pages/HansaFlexGroupPages/ResponsibilityAndSocialCommitments/ResponsibilityAndSocialCommitments';
import DonationInsteadGifts from './Pages/HansaFlexGroupPages/ResponsibilityAndSocialCommitments/DonationInsteadGifts';
import Diversity from './Pages/HansaFlexGroupPages/ResponsibilityAndSocialCommitments/Diversity';
import SystemDesign from './Pages/NewsAndEvents/SystemDesign';
import ContainerWorkshop from './Pages/NewsAndEvents/ContainerWorkshop';
import termsandcondition from './Pages/termsandcondition';
import CompatibleHydraulicHose from './Pages/NewsAndEvents/CompatibleHydraulicHose';
import HydraulicLogisticsMining from './Pages/NewsAndEvents/HydraulicLogisticsMining';
import HydraulicHoseNomenclature from './Pages/NewsAndEvents/HydraulicHoseNomenclature';
const WHATSAPP_EXCLUDED_PATHS = [
  '/contact-us', '/fale-conosco',
  '/campanha-mhs', '/campanha-mhs-pr', '/campanha-mhs-ms', '/campanha-offshore', '/campanha-mineracao-mg',
  '/campanha-mangueiras-sp-abc',
];

function GlobalWhatsApp() {
  const { pathname } = useLocation();
  if (WHATSAPP_EXCLUDED_PATHS.includes(pathname)) return null;
  return <WhatsAppChat phoneNumber="+55 (47) 99613-3321" />;
}

function App() {
  const { t } = useTranslation();

  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <div className='primary-navbar'>
            <CustomNavbar />
          </div>

        </header>
        <div className='secondary-navbar sticky-top '>
          <MainNavbarMenu />
        </div>
        <Switch>
          {/* Home Page */}
          <Route path="/" exact component={HomePage} />
          {/* <Route path="/products" component={ProductsPage} />
          <Route path="/hf-group" component={HansaFlexGroupPage} /> */}

          {/* Hansa Flex Brazil Pages */}
          <Route path="/who-we-are" component={WhoWeAre} />
          {/* <Route path="/management" component={Management} /> */}
          <Route path="/journey" component={Journey} />
          <Route path="/certificates" component={Certificates} />
          <Route path="/careers" component={Careers} />

          {/* Contact Us form and campaigns forms */}
          <Route path="/contact-us" component={ContactUs} />
          <Route path="/fale-conosco" component={ContactUsForm} />
          <Route path="/campanha-mhs" component={MhsCampaign} />
          <Route path="/campanha-mhs-pr" component={MhsprCampaign} />
          <Route path="/campanha-mhs-ms" component={MhsCampaignMS} />
          <Route path="/campanha-mineracao-mg" component={MiningCampaignMG} />
          <Route path="/campanha-offshore" component={OffshoreCampaign} />
          <Route path="/campanha-mangueiras-sp-abc" component={HydraulicHoseCampaignSPABC} />
          {/* Hansa Flex Group Management Pages */}
          <Route path="/hf-group-management" component={GroupManagement} />
          <Route path="/hf-group-certificates" component={GroupCertificates} />
          <Route path="/hf-group-history" component={GroupHistory} />
          <Route path="/hf-group-mission-statement" component={GroupMissionStatement} />
          <Route path="/hf-60-years-of-hansaflex" component={SixtyYearOfHansaflex} />
          <Route path="/annual-report" component={AnnualReport} />
          <Route path="/upcoming-events" component={UpcomingEvents} />
          <Route path="/associations" component={Associations} />
          <Route path="/responsibility-and-social-commitments" component={ResponsibilityAndSocialCommitments} />
          <Route path="/donation-instead-gifts" component={DonationInsteadGifts} />
          <Route path="/diversity" component={Diversity} />

          {/* News Pages */}
          <Route path="/news-events" component={NewsEventsPage} />
          <Route path="/Local" component={Local} />
          <Route path="/Measurement" component={Measurement} />
          <Route path="/LessHeadache" component={LessHeadache} />
          <Route path="/Nonconductivenews" component={Nonconductivenews} />
          <Route path="/x_code_identify_hoses_in_seconds" component={XCodeNews} />
          <Route path="/wear-and-tear-mining-equipment" component={WearAndTear} />
          <Route path="/hydraulic-systems-design-errors-vs-hydraulic-failures" component={SystemDesign} />
          <Route path="/hydraulic-hose-cleaning" component={HydraulicHoseCleaning} />
          <Route path="/container-workshop" component={ContainerWorkshop} />
          <Route path="/compatible-hydraulic-hose" component={CompatibleHydraulicHose} />
          <Route path="/hydraulic-logistics-mining" component={HydraulicLogisticsMining} />
          <Route path="/hydraulic-hose-nomenclature" component={HydraulicHoseNomenclature} />
          {/* Privacy Policy Page */}
          <Route path="/hansa-flex-brazil-privacy-policy" component={PrivayPolicyPage} />

          {/* Other Pages */}
          <Route path="/services" component={BrazilServicos} />

          {/* HF Products Pages */}
          <Route path="/products" component={ProductsPage} />
          <Route path="/hoses-and-hose-lines" component={HosesAndHoseLines} />
          <Route path="/hose-line-config" component={HoseLineConfigurator} />
          <Route path="/hydraulic-hoses" component={HydraulicHose} />
          <Route path="/metal-hoses" component={MetalHoses} />
          <Route path="/Industrial-hoses" component={IndustrialHoses} />
          <Route path="/performed-hoses" component={PerformedHoses} />
          <Route path="/ext-high-pfm-hoses" component={ExtremelyHighPerformanceHoses} />
          <Route path="/Ptfe-hoses" component={PtfeHoses} />
          <Route path="/hose-accessories" component={Accessories} />

          <Route path="/drive-and-control-tech" component={DriveAndControlTechnology} />
          <Route path="/pumps" component={Pumps} />
          <Route path="/hydraulic-motor" component={HydraulicMotor} />
          <Route path="/cylinder" component={Cylinder} />
          <Route path="/switches-and-sensors" component={SwitchesAndSensors} />
          <Route path="/valve-tech" component={ValveTechnology} />
          <Route path="/pipeline-installation-valve" component={PipelineInstallationValve} />
          <Route path="/cartridge-valve" component={CartridgeValves} />
          <Route path="/cetop-valve" component={CetopValves} />
          <Route path="/measuring-tech" component={MeasuringTechnology} />
          <Route path="/seven-hundred-hydraulics" component={SevenHundredBarHydraulics} />
          <Route path="/pressure-accumulators" component={PressureAccumulators} />

          <Route path="/hydraulic-connection-technology" component={HydraulicConnectionTechnology} />
          <Route path="/hose-fitting" component={HoseFittings} />
          <Route path="/pipe-fitting" component={PipeFittings} />
          <Route path="/adapters" component={Adapters} />
          <Route path="/coupling" component={Couplings} />
          <Route path="/ball-valves" component={BallValves} />
          <Route path="/flanges" component={Flanges} />

          <Route path="/sealing-tech" component={SealingTechnology} />
          <Route path="/filtration" component={Filtration} />
          <Route path="/pneumatics" component={Pneumatics} />
          <Route path="/technical-information" component={TechnicalInformation} />
          <Route path="/approvals" component={Approvals} />
          <Route path="/catalogues" component={Catalogues} />

          <Route path="/pipelines" component={Pipelines} />
          <Route path="/pipebends" component={Pipebends} />
          <Route path="/pipeend-processing" component={PipeendProcessing} />
          <Route path="/Expansionjoints" component={ExpansionJoints} />

          {/* HF Services Pages */}
          <Route path="/hose-management" component={HoseManagement} />
          <Route path="/mobile-rapid-hydraulic-service" component={MobileService} />
          <Route path="/hydraulic-academy" component={HydraulicAcademy} />

          <Route path="/fluid-service" component={FluidService} />
          <Route path="/oil-analysis" component={OilAnalysis} />
          <Route path="/oil-filtering-and-cleaning" component={OilFilteringAndCleaning} />

          <Route path="/assembly-and-installation" component={AssemblyAndInstallation} />
          <Route path="/modernisation-and-optimisation" component={ModernisationAndOptimisation} />
          <Route path="/plant-project-planning-and-management" component={PlantProjectPlanningAndManagement} />
          <Route path="/installation-of-pipe-and-hoseline-systems" component={InstallationOfPipeAndHoseLineSystems} />

          <Route path="/preventative-maintainance" component={PreventataiveMaintainance} />
          <Route path="/service-packages" component={ServicePackages} />
          <Route path="/x-code-hose-identification-system" component={XCodeIdentification} />
          <Route path="/x-code-manager" component={XCodeManager} />
          <Route path="/licenses" component={Licenses} />
          <Route path="/inspection" component={Inspection} />
          <Route path="/industrial-hose-inspection" component={IndustrialHoseInspection} />
          <Route path="/dguv-inspection" component={DguvInspection} />
          <Route path="/lifting-platforms-and-loading-bridges" component={LiftingPlatformsAndLoadingBridges} />

          <Route path="/repair-and-overhaul" component={RepairAndOverhaul} />
          <Route path="/hydraulic-cyclinder-repair" component={HydraulicCylinderRepair} />
          <Route path="/pressure-accumulators-and-associated-systems" component={PressureAccumulatorsAndAssociatedSystems} />

          <Route path="/DigitalServices" component={DigitalServices} />
          <Route path="/EDIandBMEcat" component={EDIandBMEcat} />
          <Route path="/Scannersolutions" component={Scannersolutions} />
          <Route path="/Production" component={Production} />
          <Route path="/Customisedassembly" component={CustomisedAssembly} />
          <Route path="/SeriesProduction" component={SeriesProduction} />

          <Route path="/Logisticssolutions" component={Logisticssolutions} />
          <Route path="/Warehousemanagement" component={Warehousemanagement} />
          <Route path="/Kanbandelivery" component={Kanbandelivery} />
          <Route path="/Kitting" component={Kitting} />
          <Route path="/Hydraulicworkshopcontainers" component={Hydraulicworkshopcontainers} />
          <Route path="/Worksinworks" component={Worksinworks} />

          <Route path="/Engineering" component={Engineering} />
          <Route path="/EngineeredbyHansaflex" component={EngineeredbyHansaflex} />
          <Route path="/Hydraulicunit" component={Hydraulicunit} />
          <Route path="/Prototypemanufacture" component={Prototypemanufacture} />
          <Route path="/code-of-conduct" component={Codeofconduct} />
          <Route path="/Pressureaccumulatorinspection" component={Pressureaccumulatorinspection} />
          <Route path="/general_terms_and_conditions_of_sale_and_warranty" component={termsandcondition} />
        </Switch>

        <div>
          <HfFooter />
        </div>
        <GlobalWhatsApp />
        <CookieBanner />

        {/* <CookieConsent
          location="bottom"
          buttonText={t('Continue')}
          cookieName="HFCookieConsent"
          containerClasses="cookie-consent-banner"
          style={{
            background: '#4571a2',
            color: '#fff',
            alignItems: 'center',
            padding: '12px 240px',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            gap: '12px',
          }}
          contentStyle={{ flex: '1', minWidth: 0, display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}
          buttonStyle={{
            color: '#fff',
            backgroundColor: '#d40606',
            fontSize: '14px',
            padding: '10px 24px',
            borderRadius: '4px',
            border: 'none',
            cursor: 'pointer',
          }}
          buttonWrapperClasses="cookie-consent-buttons"
          expires={365}
        >
          <span className="cookie-consent-message">
            {t('HANSA-FLEX do Brasil uses cookies to facilitate user navigation and interaction across all its websites. By clicking "Continue," you agree to our settings and our cookie policy.')}
          </span>
          <Link
            to="/hansa-flex-brazil-privacy-policy"
            className="cookie-consent-privacy-btn"
          >
            {t('Privacy Policy')}
          </Link>
        </CookieConsent> */}
      </div>
    </Router>
  );
}

export default App;
